import { render } from "./MscChangeEmailModal.vue?vue&type=template&id=659e50d9&ts=true"
import script from "./MscChangeEmailModal.vue?vue&type=script&lang=ts"
export * from "./MscChangeEmailModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__